<template>
  <complex-select
    :tb-head="Head"
    :tb-data="Data"
    :key-str="keyword"
    v-model="value1"
    @select="onSelect"
  />
</template>
<script>
import complexSelect from "@/components/common/complexSelect";
export default {
  components: {
    complexSelect,
  },
  props: {
    init: {
      type: Boolean,
      default: false,
    },
    source: {
      type: Array,
      default: () => [],
    },
    keyword: {
      type: String,
      default: "ItemName",
    },
    value: {},
  },
  data() {
    return {
      api: require("@/api/sale/item").default,
      Head: [
        // { Value: "ClassName", Name: "类别筛选", Width: "160", Custom: true },
        { Value: "ItemCode", Name: "项目编号", Width: "100" },
        { Value: "ItemName", Name: "项目名称", Width: "100" },
      ],
      Data: [],
      value1: "",
    };
  },
  watch: {
    value() {
      // 
      this.value1 = this.value;
    },
    source() {
      this.Data = this.source;
    },
  },
  mounted() {
    this.value1 = this.value;
    if (this.init) this.initData();
    else this.Data = this.source;
  },
  methods: {
    initData() {
      
      this.api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Data = res.Data;
      });
    },
    onSelect(data) {
      
      this.$emit("input", data[this.keyword]);
      this.$emit("select", data);
    },
  },
};
</script>